<div class="body">
  <form class="form" id="editForm" [formGroup]="editForm" novalidate>
    <div class="top-bar">
      <div class="content-start"></div>
      <div class="logo-div">
        <img
          src="assets/images/ecolab-logo-white-app-header.png"
          alt="EcoLab Logo"
          class="logo"
        />
      </div>
      <div class="content-end">
        <select
          [value]="currentLanguage"
          (change)="languageChange($event)"
          class="select-dropdown"
        >
          <option
            *ngFor="let option of languageOptions"
            [value]="option?.value"
            [selected]="option.value === currentLanguage"
          >
            {{ option.value }}
          </option>
        </select>
      </div>
    </div>
    <main class="grow overflow-hidden">
      <div class="h-full relative show-bottom-fade">
        <div class="h-full min-h-0 overflow-scroll border-b border-white">
          <div class="max-w-xl mx-auto pt-2 px-4">
            <div class="grid grid-cols-12 gap-2 mb-4">
              <div class="col-span-8">
                <h2 class="h2 sm:text-center">
                  {{ translations['business_details_header'] }}
                </h2>
              </div>
              <div class="col-span-4">
                <img
                  alt="EHT Dishmachine"
                  [src]="deviceData.machineImage"
                  class="max-h-32 max-w-28 mx-auto mb-4 img-dish"
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="label" for="machineType"
                >{{ translations['type_label'] }}
                <span class="sr-only">{{
                  translations['optional_label']
                }}</span>
              </label>
              <select
                id="machineType"
                class="input"
                name="machineType"
                formControlName="machineType"
                (change)="onMachineTypeChange($event)"
              >
                <option *ngIf="languageIndex == 0" value="" disabled>
                  Please select one
                </option>
                <option *ngIf="languageIndex == 1" value="" disabled>
                  Por favor, seleccione uno
                </option>
                <option
                  *ngFor="let option of machineTypes"
                  [value]="option?.value[languageIndex]"
                >
                  {{ option?.value[languageIndex] }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label class="label" for="machineModel"
                >{{ translations['model_label_esr'] }}
                <span class="sr-only">{{
                  translations['optional_label']
                }}</span>
              </label>
              <select
                id="machineModel"
                class="input"
                name="machineModel"
                formControlName="machineModel"
              >
                <option *ngIf="languageIndex == 0" value="" disabled>
                  Please select one
                </option>
                <option *ngIf="languageIndex == 1" value="" disabled>
                  Por favor, seleccione uno
                </option>
                <option
                  *ngFor="let option of machineModels"
                  [value]="option?.value[languageIndex]"
                >
                  {{ option?.value[languageIndex] }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="businessName" class="label">{{
                translations['business_name_label']
              }}</label>
              <input
                for="businessName"
                class="input"
                type="text"
                id="businessName"
                name="businessName"
                formControlName="businessName"
                maxlength="50"
                [value]="deviceData?.businessName"
              />
            </div>
            <div class="mb-3">
              <div>
                <label for="address" class="label"
                  >{{ translations['address_label'] }}
                </label>
                <input
                  for="address"
                  class="input"
                  type="text"
                  name="address"
                  id="address"
                  formControlName="address"
                  maxlength="50"
                  (input)="onAddressChange()"
                />
                <p
                  *ngIf="!isAddressValid"
                  id="name-error"
                  class="text-sm text-red-600 mb-2"
                >
                  {{ translations['address_error'] }}
                </p>
              </div>
            </div>
            <div class="mb-3">
              <div>
                <label for="city" class="label"
                  >{{ translations['city_label'] }}
                </label>
                <input
                  for="city"
                  class="input"
                  type="text"
                  id="city"
                  name="city"
                  maxlength="50"
                  formControlName="city"
                  (input)="onCityChange()"
                />
                <p
                  *ngIf="!isCityValid"
                  id="name-error"
                  class="text-sm text-red-600 mb-2"
                >
                  {{ translations['city_error'] }}
                </p>
              </div>
            </div>
            <div class="grid grid-cols-12 gap-2 mb-4">
              <div class="col-span-6">
                <label for="state" class="label"
                  >{{ translations['state_label_esr'] }}
                </label>
                <input
                  for="state"
                  class="input"
                  type="text"
                  name="state"
                  maxlength="50"
                  formControlName="state"
                  [value]="deviceData?.state"
                />
              </div>
              <div class="col-span-6">
                <label for="zip" class="label"
                  >{{ translations['zip_label_esr'] }}
                </label>
                <input
                  for="zip"
                  class="input"
                  type="text"
                  name="zip"
                  maxlength="5"
                  formControlName="zip"
                  [value]="deviceData?.zip"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div class="layout-bottom">
      <div class="max-w-xl mx-auto px-4 py-4">
        <button
          type="submit"
          class="btn-blue-outline"
          [disabled]="!isFormValid"
          (click)="navigate()"
        >
          {{ translations['continue_button'] }}
        </button>
      </div>
    </div>
  </form>
</div>
